import React, { useEffect, useState } from "react";

// Import Lucide icons
import {
  Users,
  Mail,
  Calendar,
  Globe,
  Phone,
  Clock,
  FileText,
  Download,
  Search,
  RefreshCw,
  Filter,
  ChevronDown,
  User,
  MapPin,
  MessageSquare,
} from "lucide-react";

import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import "./AdminYearlyContact.css";
import { useAlert } from "react-alert";

function AdminYearlyContact({ adminType }) {
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfForms, setnoOfForms] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [lastRefreshed, setLastRefreshed] = useState(new Date());

  const getFormData = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.getYearlyContactData(payload);
      setData(userData.contact || []);
      setnoOfForms(userData.count || 0);
      setLimit(userData.limit || 10);
      setLoader(false);
      setLastRefreshed(new Date());
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getFormData();
  }, [page, resetPage]);

  const refreshData = () => {
    getFormData();
  };

  const formatTime = (date) => {
    return moment(date).format("h:mm:ss A");
  };

  const handleExport = () => {
    // Export functionality can be implemented here
    alert.info("Export functionality will be implemented here");
  };

  return (
    <>
      <div className="yearly-contact-container-fluid yearly-contact-page">
        <div className="yearly-contact-row">
          <div className="yearly-contact-col">
            <div className="yearly-contact-header">
              <div className="yearly-contact-header-content">
                <div className="yearly-contact-title-section">
                  <div className="yearly-contact-title-icon-wrapper">
                    <FileText size={24} className="yearly-contact-title-icon" />
                  </div>
                  <div>
                    <h1 className="yearly-contact-title">
                      Yearly Contact Submissions
                    </h1>
                    <div className="yearly-contact-subtitle">
                      Manage and review yearly contact form submissions
                    </div>
                  </div>
                  <div className="yearly-contact-count-badge">
                    <span className="yearly-contact-count">{noOfForms}</span>
                    <span className="yearly-contact-count-label">
                      Total Submissions
                    </span>
                  </div>
                </div>

                <div className="yearly-contact-header-actions">
                  <div className="yearly-contact-search-wrapper">
                    <div className="yearly-contact-search-input-group">
                      <Search
                        size={24}
                        className="yearly-contact-search-icon"
                      />
                      <input
                        type="text"
                        className="yearly-contact-search-input"
                        placeholder="Search by email or name..."
                        value={searchMail}
                        onChange={(e) => setSearchMail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="yearly-contact-action-buttons">
                    <button
                      className="yearly-contact-action-button yearly-contact-action-button-filter"
                      onClick={() => setShowFilters(!showFilters)}
                    >
                      <Filter size={18} />
                      Filters
                      <ChevronDown
                        size={16}
                        className={`yearly-contact-chevron ${showFilters ? "yearly-contact-chevron-up" : ""}`}
                      />
                    </button>

                    <button
                      className="yearly-contact-action-button yearly-contact-action-button-refresh"
                      onClick={refreshData}
                      disabled={loader}
                    >
                      <RefreshCw
                        size={18}
                        className={loader ? "yearly-contact-spinner" : ""}
                      />
                      Refresh
                    </button>

                    {/* <button 
                      className="yearly-contact-action-button yearly-contact-action-button-export"
                      onClick={handleExport}
                    >
                      <Download size={18} />
                      Export
                    </button> */}
                  </div>
                </div>
              </div>

              {/* <div className="yearly-contact-stats-container">
                <div className="yearly-contact-stat-card">
                  <div className="yearly-contact-stat-icon yearly-contact-stat-icon-submissions">
                    <FileText size={20} />
                  </div>
                  <div className="yearly-contact-stat-content">
                    <span className="yearly-contact-stat-label">Total Submissions</span>
                    <span className="yearly-contact-stat-value">{noOfForms}</span>
                  </div>
                </div>
                
                <div className="yearly-contact-stat-card">
                  <div className="yearly-contact-stat-icon yearly-contact-stat-icon-country">
                    <Globe size={20} />
                  </div>
                  <div className="yearly-contact-stat-content">
                    <span className="yearly-contact-stat-label">Countries</span>
                    <span className="yearly-contact-stat-value">
                      {[...new Set(data.map(item => item?.country).filter(Boolean))].length}
                    </span>
                  </div>
                </div>
                
                <div className="yearly-contact-stat-card">
                  <div className="yearly-contact-stat-icon yearly-contact-stat-icon-phone">
                    <Phone size={20} />
                  </div>
                  <div className="yearly-contact-stat-content">
                    <span className="yearly-contact-stat-label">With Phone</span>
                    <span className="yearly-contact-stat-value">
                      {data.filter(item => item?.phone).length}
                    </span>
                  </div>
                </div>
                
                <div className="yearly-contact-stat-card">
                  <div className="yearly-contact-stat-icon yearly-contact-stat-icon-updated">
                    <Clock size={20} />
                  </div>
                  <div className="yearly-contact-stat-content">
                    <span className="yearly-contact-stat-label">Last Updated</span>
                    <span className="yearly-contact-stat-time">{formatTime(lastRefreshed)}</span>
                  </div>
                </div>
              </div> */}

              {showFilters && (
                <div className="yearly-contact-filters-panel">
                  <div className="yearly-contact-filters-header">
                    <h3 className="yearly-contact-filters-title">Filters</h3>
                    <button
                      className="yearly-contact-filters-close"
                      onClick={() => setShowFilters(false)}
                    >
                      ✕
                    </button>
                  </div>
                  <div className="yearly-contact-filters-content">
                    <div className="yearly-contact-filter-group">
                      <label className="yearly-contact-filter-label">
                        Date Range
                      </label>
                      <div className="yearly-contact-filter-inputs">
                        <input
                          type="date"
                          className="yearly-contact-filter-input"
                        />
                        <span className="yearly-contact-filter-separator">
                          to
                        </span>
                        <input
                          type="date"
                          className="yearly-contact-filter-input"
                        />
                      </div>
                    </div>
                    <div className="yearly-contact-filter-group">
                      <label className="yearly-contact-filter-label">
                        Country
                      </label>
                      <select className="yearly-contact-filter-select">
                        <option value="">All Countries</option>
                        {[
                          ...new Set(
                            data.map((item) => item?.country).filter(Boolean),
                          ),
                        ].map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button className="yearly-contact-apply-filters">
                      Apply Filters
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="yearly-contact-table-container">
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfForms={noOfForms}
                limit={limit}
                adminType={adminType}
              />
            </div>
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfForms, limit }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    if (!date) return "-";
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <div className="yearly-contact-card">
      <div className="yearly-contact-card-header">
        <div className="yearly-contact-card-title">
          <h2>Contact Form Submissions</h2>
          <span className="yearly-contact-card-subtitle">
            Showing {data.length} of {noOfForms} submissions
          </span>
        </div>
      </div>

      <div className="yearly-contact-table-wrapper">
        {/* Always show the table with header */}
        <table className="yearly-contact-table">
          <thead className="yearly-contact-table-header">
            <tr>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <User size={16} />
                  <span>Name</span>
                </div>
              </th>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <Mail size={16} />
                  <span>Email</span>
                </div>
              </th>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <Calendar size={16} />
                  <span>Date of Birth</span>
                </div>
              </th>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <Globe size={16} />
                  <span>Country</span>
                </div>
              </th>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <Phone size={16} />
                  <span>Phone</span>
                </div>
              </th>
              <th className="yearly-contact-table-th">
                <div className="yearly-contact-table-header-cell">
                  <Clock size={16} />
                  <span>Submission Time</span>
                </div>
              </th>
            </tr>
          </thead>

          {/* Conditionally render body content */}
          <tbody className="yearly-contact-table-body">
            {data.length === 0 ? (
              <tr>
                <td colSpan="6" className="yearly-contact-table-td">
                  <div className="yearly-contact-empty-state">
                    <div className="yearly-contact-empty-state-icon">
                      <MessageSquare size={48} />
                    </div>
                    <h3 className="yearly-contact-empty-state-title">
                      No Contact Submissions Found
                    </h3>
                    <p className="yearly-contact-empty-state-description">
                      There are currently no yearly contact form submissions in
                      the system.
                    </p>
                    <div className="yearly-contact-empty-state-actions">
                      <button className="yearly-contact-empty-state-button">
                        <RefreshCw size={16} />
                        Refresh Data
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((item, key) => (
                <tr key={key} className="yearly-contact-table-row">
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-user-info">
                      <div className="yearly-contact-user-avatar">
                        {item?.name?.charAt(0) || "U"}
                      </div>
                      <div className="yearly-contact-user-details">
                        <span className="yearly-contact-user-name">
                          {item?.name || "N/A"}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-email-cell">
                      <Mail size={14} className="yearly-contact-email-icon" />
                      <a
                        href={`mailto:${item?.email}`}
                        className="yearly-contact-email"
                        title="Send email"
                      >
                        {item?.email}
                      </a>
                    </div>
                  </td>
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-date-cell">
                      <Calendar
                        size={14}
                        className="yearly-contact-date-icon"
                      />
                      <span>{item?.dob || "-"}</span>
                    </div>
                  </td>
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-country-cell">
                      {item?.country ? (
                        <>
                          <Globe
                            size={14}
                            className="yearly-contact-country-icon"
                          />
                          <span className="yearly-contact-country-name">
                            {item.country}
                          </span>
                        </>
                      ) : (
                        <span className="yearly-contact-no-data">-</span>
                      )}
                    </div>
                  </td>
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-phone-cell">
                      {item?.phone ? (
                        <>
                          <Phone
                            size={14}
                            className="yearly-contact-phone-icon"
                          />
                          <a
                            href={`tel:${item.phone}`}
                            className="yearly-contact-phone"
                            title="Call"
                          >
                            {item.phone}
                          </a>
                        </>
                      ) : (
                        <span className="yearly-contact-no-data">-</span>
                      )}
                    </div>
                  </td>
                  <td className="yearly-contact-table-td">
                    <div className="yearly-contact-timestamp-cell">
                      <Clock
                        size={14}
                        className="yearly-contact-timestamp-icon"
                      />
                      <div className="yearly-contact-timestamp-details">
                        <span className="yearly-contact-timestamp-date">
                          {formatDate(item?.createdAt).split(",")[0]}
                        </span>
                        <span className="yearly-contact-timestamp-time">
                          {formatDate(item?.createdAt).split(",")[1]}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {noOfForms > limit && data.length > 0 && (
          <div className="yearly-contact-pagination-container">
            <div className="yearly-contact-pagination-info">
              Page {page} of {Math.ceil(noOfForms / limit)}
            </div>
            <div className="yearly-contact-pagination">
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noOfForms / limit)}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminYearlyContact;
